import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Chip from '@material-ui/core/Chip';
import { STATUS_COLORS, WAITING_COLOR, COMPLAINT_STATUSES } from '../constants';

export function getStatusColor(status, view) {
  if (status === COMPLAINT_STATUSES.PENDING_HOST) {
    return view === 'host' ? STATUS_COLORS[status] : WAITING_COLOR;
  }
  if (status === COMPLAINT_STATUSES.PENDING_GUEST) {
    return view === 'guest' ? STATUS_COLORS[status] : WAITING_COLOR;
  }
  return STATUS_COLORS[status] || null;
}

const guestConfig = {
  pending_host: {
    labelId: 'complaints.status.pendingHost',
    defaultMessage: 'Awaiting host',
  },
  pending_guest: {
    labelId: 'complaints.status.pendingGuest',
    defaultMessage: 'Awaiting your response',
  },
  accepted: { labelId: 'complaints.status.accepted', defaultMessage: 'Accepted' },
  escalated: {
    labelId: 'complaints.status.escalated',
    defaultMessage: 'Escalated',
  },
  resolved: { labelId: 'complaints.status.resolved', defaultMessage: 'Resolved' },
  withdrawn: {
    labelId: 'complaints.status.withdrawn',
    defaultMessage: 'Withdrawn',
  },
};

const hostConfig = {
  ...guestConfig,
  pending_host: {
    labelId: 'complaints.status.pendingHost.host',
    defaultMessage: 'Awaiting your response',
  },
  pending_guest: {
    labelId: 'complaints.status.pendingGuest.host',
    defaultMessage: 'Awaiting guest',
  },
};

const ComplaintStatusBadge = ({ status, view, size }) => {
  const config = (view === 'host' ? hostConfig : guestConfig)[status];
  if (!config) return null;

  const color = getStatusColor(status, view);
  const chipProps = color ? { style: color } : { variant: 'outlined' };

  return (
    <Chip
      size={size || 'small'}
      {...chipProps}
      label={<FormattedMessage id={config.labelId} defaultMessage={config.defaultMessage} />}
    />
  );
};

ComplaintStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  view: PropTypes.oneOf(['guest', 'host']),
  size: PropTypes.string,
};

export default ComplaintStatusBadge;
